<template>
    <div>
        <h3>壁打ち</h3>
        <p>
            「壁打ち」は、執筆中に浮かんでくるアイデアや雑念、ぼやき、
            一言に掲載するほどでもない取るに足らないことを垂れ流す機能です。
            一言と異なり、ワンライナーの短い発言を多数投稿するチャット形式の機能です。
            壁打ちを開始すると、あなたの本棚に投稿がリアルタイムに配信されます。
        </p>
        <p>
            一件でも壁打ちに投稿していると、読者からメッセージが返ってくることがあります。
            このメッセージは作者が承認するまで他の人には表示されません。
        </p>
        <h4>使い方</h4>
        <p>
            ポータル、あるいはマイページの右下に壁打ちボタンが表示されています。
            これをクリックすると、壁打ちウインドウが開きます。
        </p>
        <div class="d-flex justify-content-start">
            <img src="/img/help/other/16.jpg" alt="壁打ち開始" class="img-thumbnail w-50 mb-3">
            <img src="/img/help/other/17.jpg" alt="壁打ち開始" class="img-thumbnail w-50 mb-3">
        </div>
        <p>
            壁打ちを開始すると、最下部にテキスト入力欄が表示されます。
            500文字までの短文を投稿できます。
        </p>
        <p>
            左の画像ボタンをクリックすると、画像投稿ができます。
            最大で5MBまでのjpg、png、gif、webp画像を投稿することができます。
            画像投稿においてもコメント文字列は必須です。
        </p>
        <p>
            投稿した内容は、即座にあなたの本棚に配信されます。
            投稿は常にリアルタイムですが、256件を超えると、古い投稿から消えていきます。
        </p>
        <p>
            投稿内容がセンシティブになる場合は、上部の制限文字列をクリックして、レーティングを変更してください。
        </p>
        <p>
            配信コメントに視聴者が「いいね」をクリックすることがあります。
            いいね数は即座に反映されます。
        </p>
        <h4>投稿の制限</h4>
        <p>
            壁打ち画面では購読中の壁打ちを含めて最大256件の投稿が表示されます。
            それを超える投稿を受け取った場合、最も古いものが消滅します。
        </p>
        <h4>読者の投稿</h4>
        <p>
            作者が一件以上の壁打ち投稿をしている場合、読者がそこに返信してくるかもしれません。
            初めて投稿する読者の書き込みは、作者が承認するまで他の人には表示されません。
            読者の名前の左側に表示される承認アイコン
            <span class="badge badge-success badge-pill">
                <i class="fas fa-check"></i>
                承認
            </span>
            をクリックして承認してください。
        </p>
        <p>
            知らない間に読者からメッセージをもらいたくないという場合は、壁打ちを一件も投稿しないか、
            投稿した後で左上のクリアボタンで投稿を全削除してください。
        </p>
        <h4>不適切な投稿</h4>
        <p>
            他の機能同様に、
        </p>
        <ol>
            <li>作者や作品への誹謗中傷</li>
            <li>宣伝、勧誘など規約に反する内容</li>
        </ol>
        <p>
            このような不適切な投稿はおやめください。
            このような不適切な投稿を読者から受け取った場合、承認せずに無視するか、その読者を壁打ちから排除することができます。
        </p>
        <p>
            読者の右側の
            <i class="fas fa-ban text-danger"></i>
            アイコンをクリックすると、指定した読者を排除できます。
            排除された読者の投稿はすべて削除され、その読者は壁打ちが即座に閉じられ、開けなくなります。
            未承認の読者だけでなく、承認済み読者であっても任意に排除することができます。
        </p>
        <h4>レーティング</h4>
        <p>
            壁打ち自体にレーティングを設定することができます。
            ウインドウ上部の「全年齢」をクリックすると、レーティングのドロップダウンが表示されます。
        </p>
        <p>
            レーティングを設定すると即座に反映され、現在視聴している人がレーティングに抵触する場合、
            壁打ちウインドウも即座に閉じられ、再度開くことができなくなります。
        </p>
        <h4>投稿の削除</h4>
        <p>
            投稿は個別に削除することはできません。
            そのまま放置しても、決まった件数以上の投稿が追加されると、古いものから消えていきます。
        </p>
        <p>
            オフラインのときに壁打ちを見られたくない、返信されたくない場合は、
            左上のゴミ箱アイコン
            <i class="fas fa-trash"></i>
            をクリックして、読者の投稿を含むすべての投稿を全削除することができます。
            一件も投稿が無い状態では、作者以外に壁打ちに書き込むことはできません。
        </p>
        <h4>視聴者数</h4>
        <p>
            壁打ちウインドウの上部に視聴者数が表示されます。
            これは投稿を行っている作者もカウントします。
        </p>
        <p>
            この人数は目安で、しばしば実数と異なることがあります。
        </p>
        <h4>コマンド</h4>
        <p>
            コマンド文字列を投稿することで、特殊な操作を実行することができます。
            コマンドの投稿とその結果は配信されません。
            排除ユーザーの一覧を表示しても、読者はその一覧を知ることはできません。
        </p>
        <p>
            作者（壁打ちの所有者）は以下のコマンドを実行できます。
        </p>
        <ul>
            <li>/banned…排除されたユーザー一覧を表示します。{id}: {user_name}という形式で表示されます。</li>
            <li>/restore {id}…排除されたユーザーを復帰させます。</li>
        </ul>
        <p>
            読者は以下のコマンドを実行できます。
        </p>
        <ul>
            <li>/rename {name}…投稿名を{name}に書き換えます。16文字以内です。</li>
        </ul>
        <h4>壁打ちを使いたくない</h4>
        <p>
            誰にも邪魔されずに執筆したいのに、あなたのデスクでミツバチが巣作りを始めていたら気になって仕方がないでしょう。
            壁打ちに一件も投稿しなければ、読者は投稿できません。
            壁打ちを投稿したとしても、クリアボタンですべての投稿を削除すれば、誰にも邪魔されずに静かな時間を取り戻すことができます。
        </p>
    </div>
</template>


<style src="../help.scss" scoped lang="scss"></style>


<script>
export default {
    created() {
        this.useHead({
            title: "壁打ち | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>